import styled from "styled-components";

export const StyledButton = styled.button`
    background-color: inherit;
    border: none;
    padding: 0;
    width: fit-content;
    cursor: pointer;
    padding: 0.3rem 0.5rem;
    &:hover {
        background-color: ${globalThis.config.colors.gray7};
        border: none;
        box-shadow: none;
        outline: none;
    }
    &:active {
        background-color: ${globalThis.config.colors.gray5};
        border: none;
        box-shadow: none;
        outline: none;
    }
    &:focus {
        border: none;
        box-shadow: none;
        outline: none;
        outline: none;
    }
`;
